import Navbar from "./Navbar";
import styled from "styled-components";
import LandingImage from "../img/LandingImage.jpg";
import { motion } from "framer-motion";
import {useTranslation} from "react-i18next"
import { Hidden, InitialAnimation } from "./Animations";
const LandingPage = ({t}) => {

  const width = window.innerWidth 
  const height = width / 3
  return (
    <StyledSticky>
      <StyledWrapper className="background">
        <AnimationWrapper variants={InitialAnimation} initial="hidden" animate="show" className="animations-wrapper">
        <Navbar variants={InitialAnimation} t={t}/>
        <StyledImage className="image">
          <motion.img height={height} width={width} variants={InitialAnimation} src="https://res.cloudinary.com/blazejbatko/image/upload/f_auto,q_auto/v1666352725/Personal%20site/LandingImage_ort4xb.jpg" alt="" />
        </StyledImage>
        <motion.div className="container-right">
          <StyledJunior>
            <motion.h1 variants={InitialAnimation}>
              JUNIOR FRONTEND DEVELOPER
            </motion.h1>
            <motion.p variants={InitialAnimation}>{t('location')}</motion.p>
          </StyledJunior>
        </motion.div>
        </AnimationWrapper>
        <StyledHi>
          <h2>{t('description_title')}</h2>
          <p>
            {t('description')}
            
          </p>
        </StyledHi>
      </StyledWrapper>
    </StyledSticky>
  );
};

export default LandingPage;

const AnimationWrapper = styled(motion.div)`
  
`
const StyledSticky = styled.div``;
const StyledWrapper = styled(motion.div)`
  .container-right {
  }
`;
const StyledImage = styled.div`
 
  position: sticky;
  top: 0;
  z-index: 0;
  img {
    box-shadow: 20px 20px 0 #221b1a;;
    width: 50%;
    margin: 2rem 0 0 2rem;
  }

  @media (max-width: 768px) {
    img {
      width: 80%;
    }
  }
`;

const StyledHi = styled.div`
  position: sticky;
  top: 0;
  z-index: 0;
  max-width: 50%;
  padding: 2rem;
  margin-bottom: 4rem;
  h2,
  p {
    color: #f8f8f8;
  }
  h2 {
    font-size: 3rem;
    letter-spacing: 5px;
  }
  p {
    font-size: 2rem;
  }

  @media (max-width: 768px) {
    max-width: 80%;
  }
`;
const StyledJunior = styled(motion.div)`
  position: sticky;
  top: 0;
  z-index: 0;
  
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: end;

  margin: 2rem 2rem 0 0;
  h1,
  p {
    color: #f8f8f8;
  }
  h1 {
    font-size: 7rem;
  }
  p {
    font-size: 1.7rem;
  }
`;
